import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';
import { RichTextEditorState } from './types';

const initState = () => {
    return new RichTextEditorState();
};

export const useRichTextEditorModule = createStoreModule<RichTextEditorState, IAction<RichTextEditorState>>(
    initState,
    'app-rich-text-editor'
);
